<template>
  <div style="height: 360px">
    <el-table :data="partsList" max-height="360" v-show="quick">
      <el-table-column show-overflow-tooltip prop="name" label="定损部件">
        <template #default="{ row }">
          <el-checkbox :disabled="row.fixed" v-model="row.isPaint" @input="partsSelectChange(row)">{{row.name}}
          </el-checkbox>
        </template>
      </el-table-column>
      <el-table-column label="油漆幅数" width="160">
        <template #default="{ row }">
          <half-step-input :disabled="row.fixed" v-model="row.paintArea" v-show="row.isPaint" class="fullwidth"
                           size="mini"></half-step-input>
        </template>
      </el-table-column>
      <el-table-column v-if="quick" width="200">
      </el-table-column>
    </el-table>

    <el-table v-show="!quick" :data="partsList" max-height="360">
      <el-table-column show-overflow-tooltip prop="name" label="定损部件">
        <template #default="{ row }">
          <el-checkbox :disabled="row.fixed" v-model="row.selected" @input="partsSelectChange(row)">{{row.name}}
          </el-checkbox>
        </template>
      </el-table-column>
      <el-table-column label="维修类型" width="120">
        <template #default="{ row }">
          <div style="display: flex; flex-direction: column; justify-content: space-between; height: 80px;"
               v-show="row.selected">
            <el-checkbox :disabled="row.fixed || (!work.allowSheetMetalProcedure && !work.allowAssemblyProcedure)"
                         v-model="row.isSheetMetal" @input="sheetMetalChange(row)" size="big">钣金
            </el-checkbox>
            <el-checkbox :disabled="row.fixed || !work.allowPaintProcedure"
                         v-model="row.isPaint" @input="paintChange(row)" size="big">喷漆
            </el-checkbox>
            <el-checkbox :disabled="row.fixed || !work.allowDisassemblyProcedure"
                         v-model="row.isDisassembly" @input="disassemblyChange(row)" size="big">拆检
            </el-checkbox>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="损伤程度" width="240">
        <template #default="{ row }">
          <div style="height: 80px" v-show="row.selected">
            <damage-degree-select sheet-metal
                                  :disabled="row.fixed || (!work.allowSheetMetalProcedure && !work.allowAssemblyProcedure)"
                                  v-model="row.sheetMetalDegree"
                                  style="height: 27px;" @input="sheetMetalDegreeChange(row)"></damage-degree-select>
            <damage-degree-select :disabled="row.fixed || !work.allowPaintProcedure"
                                  v-model="row.paintDegree"
                                  style="height: 26px;" @input="paintDegreeChange(row)"></damage-degree-select>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="工时/幅数" width="110">
        <template #default="{ row }">
          <div style="height: 81px; display: flex; flex-direction: column;" class="normal" v-show="row.selected">
            <half-step-input :disabled="row.fixed || !work.allowSheetMetalProcedure"
                             v-model="row.sheetMetalWH" size="mini"
                             style="margin-top: -0px"></half-step-input>
            <half-step-input :disabled="row.fixed || !work.allowPaintProcedure"
                             v-model="row.paintArea" size="mini"
                             style="margin-top: 3px"></half-step-input>
            <half-step-input :disabled="row.fixed || !work.allowDisassemblyProcedure"
                             v-model="row.disassemblyWH" size="mini"
                             style="margin-top: 3px"></half-step-input>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

  import HalfStepInput from '@/components/NumberInput/HalfStepInput'
  import DamageDegreeSelect from '@/components/selector/DamageDegreeSelect'
  import { shareDataMixin } from '@/views/mixins/ShareData'

  export default {
    name: 'PartsTable',
    mixins: [shareDataMixin],
    components: {
      DamageDegreeSelect,
      HalfStepInput
    },
    props: {
      partsList: {
        type: Array,
        required: true
      },
      repairType: {
        type: String,
        required: true
      },
      work: {
        type: Object,
        required: true
      }
    },
    methods: {
      sheetMetalDegreeChange (parts) {
        const partsCoe = this.partsCoeMap[parts.id]
        if (this.work.allowSheetMetalProcedure) {
          parts.sheetMetalWH = partsCoe.sheetMetalCoe[parts.sheetMetalDegree][0]
        }
        if (this.work.allowAssemblyProcedure) {
          parts.assemblyWH = partsCoe.assemblyCoe[0]
        }
        parts.isSheetMetal = true
      },
      paintDegreeChange (parts) {
        const partsCoe = this.partsCoeMap[parts.id]
        parts.paintArea = partsCoe.paintCoe[parts.paintDegree][0]
        parts.isPaint = true
      },
      sheetMetalChange (parts) {
        if (!parts.isSheetMetal) {
          parts.sheetMetalDegree = null
          parts.sheetMetalWH = 0
        }
      },
      paintChange (parts) {
        if (!parts.isPaint) {
          parts.paintDegree = null
          parts.paintArea = 0
        }
      },
      disassemblyChange (parts) {
        const partsCoe = this.partsCoeMap[parts.id]
        if (parts.isDisassembly) {
          parts.disassemblyWH = partsCoe.disassemblyCoe[0]
        } else {
          parts.disassemblyWH = 0
        }
      },
      partsSelectChange (parts) {
        const partsCoe = this.partsCoeMap[parts.id]
        parts.paintArea = partsCoe.paintCoe.LOCAL[0]
        if (!partsCoe) {
          this.$alert('该部件没有配置默认系数，请在系数管理页面配置!', {
            confirmButtonText: '确定'
          }).catch(() => {
          })
          if (this.quick) {
            parts.isPaint = false
          } else {
            parts.selected = false
          }
          return
        } else {
            // 默认选中
            parts.isSheetMetal = true
            parts.isPaint = true
            parts.sheetMetalDegree = 'MEDIUM'
            parts.paintDegree = 'FULL'
            if (this.work.allowSheetMetalProcedure) {
              parts.sheetMetalWH = partsCoe.sheetMetalCoe.MEDIUM[0]
            }
            parts.paintArea = partsCoe.paintCoe.FULL[0]
        }
        if (this.quick) {
          parts.paintArea = partsCoe.quickCoe[0]
        }
      }
    },
    computed: {
      quick () {
        return this.repairType === 'QUICK'
      }
    },
    watch: {
      quick (value) {
        if (!value) return
        for (const parts of this.partsList) {
          if (parts.isPaint) {
            const partsCoe = this.partsCoeMap[parts.id]
            parts.paintArea = partsCoe.quickCoe[0]
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .normal {
    .el-input--mini, .el-input__inner {
      height: 25px !important;
      line-height: 25px !important;
    }

    .el-input-number__increase {
      height: 12px !important;
      top: 1px;
    }

    .el-input-number__decrease {
      height: 12px !important;
      top: 12px !important;
    }
  }
</style>
